import '@angular/localize/init';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContattiComponent } from './common-component/contatti/contatti.component';
import { DatiAnagraficiComponent } from './common-component/dati-anagrafici/dati-anagrafici.component';
import { DatiResidenzaComponent } from './common-component/dati-residenza/dati-residenza.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { MatTableModule } from '@angular/material/table';
import { TranslateModule } from '../translate/translate.module';
import { DatiDomicilioComponent } from './common-component/dati-domicilio/dati-domicilio.component';
import { RichiedenteComponent } from './components/richiedente/richiedente.component';
import { I18nLibModule, I18N_CONFIG } from 'portal-i18n-lib';
import { MatSelectModule } from '@angular/material/select';
import { MatNativeDateModule, NativeDateAdapter } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatRadioModule } from "@angular/material/radio";
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DelegheComponent } from './components/deleghe/deleghe.component';
import { GenericModalComponent } from './common-component/generic-modal/generic-modal.component';
import { TipologicheService } from './services/tipologiche/tipologiche.service';
import { DelegheService } from './services/deleghe-services/deleghe.service';
import { PersonaFisicaComponent } from './common-component/persona-fisica/persona-fisica.component';
import { MatDatepickerModule } from "@angular/material/datepicker";
import { InfoPfComponent } from './common-component/info-pf/info-pf.component';
import { InfoNascitaComponent } from './common-component/info-nascita/info-nascita.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CodiceFiscaleServiceImpl } from './services/codice-fiscale/codice-fiscale-impl.service';
import { ValidationService } from './services/validation.service';
import { ConfigurationService } from '../configuration/configuration-service';
import { CodiceFiscaleService } from './services/codice-fiscale/codice-fiscale.service';
import { PersonaGiuridicaComponent } from './common-component/persona-giuridica/persona-giuridica.component';
import { IndirizzoComponent } from './common-component/indirizzo/indirizzo.component';
import { IndirizzoItalianoComponent } from './common-component/indirizzo/indirizzo-italiano/indirizzo-italiano.component';
import { IndirizzoEsteroComponent } from './common-component/indirizzo/indirizzo-estero/indirizzo-estero.component';
import { StradaComponent } from './common-component/strada/strada.component';
import { LocalitaComponent } from './common-component/localita/localita.component';
import { MatOptionModule } from "@angular/material/core";
import { MatListModule } from "@angular/material/list";
import { AccettazioneComponent } from './components/accettazione/accettazione.component';
import { DocumentazioneComponent } from './components/documentazione/documentazione.component';
import { CaricaDocumentiComponent } from './components/documentazione/carica-documenti/carica-documenti.component';
import { TipologiaDepositoComponent } from './components/tipologia-deposito/tipologia-deposito.component';
import { AllegatiModule } from '../allegati/allegati.module';
import { DatiTribunaleComponent } from './common-component/dati-tribunale/dati-tribunale.component';
import { PagamentoComponent } from './components/pagamento/pagamento.component';
import { DatiDeposito } from './components/dati-deposito/dati-deposito.component';
import { TabellaDocumentiComponent } from './common-component/tabella-documenti/tabella-documenti.component';
import { MatSortModule } from '@angular/material/sort';
import { AltriSoggettiComponent } from './components/altri-soggetti/altri-soggetti.component';
import { StepperNavigatorComponent } from './common-component/stepper-navigator/stepper-navigator.component';
import { RicercaPfComponent } from './common-component/ricerca-pf/ricerca-pf.component';
import { RicercaPgComponent } from './common-component/ricerca-pg/ricerca-pg.component';
import { PgComponent } from './common-component/ricerca-pg/pg/pg.component';
import { PfComponent } from './common-component/ricerca-pf/pf/pf.component';
import { TabellaSediComponent } from './common-component/persona-giuridica/tabella-sedi/tabella-sedi.component';
import { InfoTipModule } from '../info-tip/info-tip.module';
import {
		DateAdapter,
	MAT_DATE_LOCALE,
	MAT_DATE_FORMATS,
} from "@angular/material/core";
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter, MomentDateModule } from '@angular/material-moment-adapter';
import { UppercaseModule } from '../directives/upper-case.module';

export const MY_DATE_FORMATS = {
	parse: {
		dateInput: "DD/MM/YYYY",
	},
	display: {
		dateInput: "DD/MM/YYYY",
		monthYearLabel: "MM YYYY",
		dateA11yLabel: "DD/MM/YYYY",
		monthYearA11yLabel: "MM YYYY",
	},
};

NativeDateAdapter

// export function delegheServiceFactory(http: HttpClient, injector: Injector) {
// 	return new DelegheService(http, injector);
// }

export function codiceFiscaleServiceFactory(http: HttpClient, conf: ConfigurationService) {
	// return !environment.isMock
	// 	? new CodiceFiscaleServiceImpl(http, paths)
	// 	: new CodiceFiscaleServiceMock();
	return new CodiceFiscaleServiceImpl(http, conf)
}

export function validationServiceFactory(checkCFService: CodiceFiscaleService) {
	return new ValidationService(checkCFService)
}

@NgModule({
	declarations: [
		ContattiComponent,
		DatiAnagraficiComponent,
		DatiDomicilioComponent,
		DatiResidenzaComponent,
		RichiedenteComponent,
		DelegheComponent,
		GenericModalComponent,
		PersonaFisicaComponent,
		InfoPfComponent,
		InfoNascitaComponent,
		PersonaGiuridicaComponent,
		IndirizzoComponent,
		IndirizzoItalianoComponent,
		IndirizzoEsteroComponent,
		StradaComponent,
		LocalitaComponent,
		AccettazioneComponent,
		DocumentazioneComponent,
		CaricaDocumentiComponent,
		TipologiaDepositoComponent,
		PagamentoComponent,
		DatiTribunaleComponent,
		DatiDeposito,
		TabellaDocumentiComponent,
		AltriSoggettiComponent,
		StepperNavigatorComponent,
		RicercaPfComponent,
		RicercaPgComponent,
		PgComponent,
		PfComponent,
		TabellaSediComponent
	],
	entryComponents: [GenericModalComponent],
	imports: [
		CommonModule,
		HttpClientModule,
		MatTableModule,
		TranslateModule,
		MatExpansionModule,
		I18nLibModule,
		MatSelectModule,
		MatNativeDateModule,
		MatButtonModule,
		MatCardModule,
		MatInputModule,
		ReactiveFormsModule,
		MatFormFieldModule,
		MatDialogModule,
		MatPaginatorModule,
		MatIconModule,
		MatProgressBarModule,
		MatRadioModule,
		MatCheckboxModule,
		MatDatepickerModule,
		MatOptionModule,
		MatListModule,
		AllegatiModule,
		UppercaseModule,
		NgbModule,
		MatSortModule,
		InfoTipModule,
		MomentDateModule
	],
	exports: [
		RichiedenteComponent,
		DelegheComponent,
		AccettazioneComponent,
		DocumentazioneComponent,
		TipologiaDepositoComponent,
		PagamentoComponent,
		DatiDeposito,
		StepperNavigatorComponent,
		AltriSoggettiComponent,
		RicercaPgComponent,
		RicercaPfComponent,
		AltriSoggettiComponent,
		GenericModalComponent,
		DatiTribunaleComponent,
		IndirizzoComponent,
		ContattiComponent,
		PersonaFisicaComponent,
		PersonaGiuridicaComponent,
		TabellaSediComponent,
		UppercaseModule
	],
	providers: [
		// {
		// 	provide: I18N_CONFIG,
		// 	useValue: {
		// 		codiceApplicazione: "LP"
		// 	}
		// },
		// {
		// 	provide: TipologicheService
		// },
		{
			provide: CodiceFiscaleService,
			useFactory: codiceFiscaleServiceFactory,
			deps: [HttpClient, ConfigurationService]
		},
		// {
		// 	provide: DelegheService,
		// 	// useFactory: delegheServiceFactory,
		// 	// deps: [HttpClient, Injector],
		// },
		{
			provide: ValidationService,
			useFactory: validationServiceFactory,
			deps: [CodiceFiscaleServiceImpl]
		},
		{ provide: MAT_DATE_LOCALE, useValue: "it-IT" },
		{ provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
		{provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: {strict: true}},
		{
			provide: DateAdapter,
			useClass: MomentDateAdapter,
			deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
		},
		// {  provide: MatPaginatorIntl, useValue: PaginatorMultiLanguage.getLinguagePaginatorIntl() },
	],
})
export class DepositiModule { }
